import React from 'react';
import { Box, Typography } from '@mui/material';
import ScrollFadeWrapper, {
  ScrollFadeSection,
} from '../../ScrollFadeWrapper/ScrollFadeWrapper';

const CARD_SHADOW =
  '0px 1px 2px 0px rgba(162, 172, 177, 0.2), 0px 12px 24px -4px rgba(22, 47, 59, 0.12)';

const badgeStyles = {
  position: 'absolute',
  top: '-16px',
  left: '20px',
  width: '72px',
  height: '72px',
  borderRadius: '20px',
  backgroundColor: '#C7CA00',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  boxShadow: '0px 6px 16px 0px #162F3B14',
};

const numberStyles = {
  fontFamily: 'Pally, Inter, sans-serif',
  fontWeight: 700,
  fontSize: '3rem',
  lineHeight: '1',
  letterSpacing: '-0.03em',
  color: '#162F3B',
};

const formatCardText = (text = '') => String(text).replace(/\r?\n/g, '<br />');

const KeyPointHorizontalNumericMobileComponent = ({ data }) => {
  const { cards = [] } = data || {};

  return (
    <ScrollFadeSection
      component="section"
      sx={{
        width: '100%',
        maxWidth: '100vw',
        position: 'relative',
        px: '16px',
        pt: '24px',
        pb: '24px',
        boxSizing: 'border-box',
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          top: '104px',
          bottom: '56px',
          left: 0,
          right: 0,
          backgroundColor: '#E3E6E8',
          borderRadius: '34px',
        }}
      />

      <Box
        sx={{
          position: 'relative',
          display: 'flex',
          flexDirection: 'column',
          gap: '32px',
          px: '12px',
        }}
      >
        {cards.map(({ number, text }, index) => (
          <ScrollFadeWrapper key={`${number}-${index}`} delay={index * 0.1}>
            <Box
              sx={{
                position: 'relative',
                backgroundColor: '#FFFFFF',
                borderRadius: '28px',
                pt: '72px',
                px: '24px',
                pb: '24px',
                boxSizing: 'border-box',
                boxShadow: CARD_SHADOW,
                display: 'flex',
                justifyContent: 'center',
              }}
            >
              <Box sx={badgeStyles}>
                <Typography sx={numberStyles}>{number}</Typography>
              </Box>

              <Box
                component="div"
                sx={{
                  fontFamily: 'Inter, sans-serif',
                  fontWeight: 700,
                  fontSize: '1.125rem',
                  lineHeight: '1.35rem',
                  letterSpacing: '-0.03em',
                  color: '#162F3B',
                  textAlign: 'left',
                  maxWidth: '220px',
                }}
                dangerouslySetInnerHTML={{ __html: formatCardText(text) }}
              />
            </Box>
          </ScrollFadeWrapper>
        ))}
      </Box>
    </ScrollFadeSection>
  );
};

export default KeyPointHorizontalNumericMobileComponent;
